import React from 'react'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { Container, Paper, useMediaQuery } from '@material-ui/core'
import FlexView from 'react-flexview/lib'
import { ActivePoliciesList } from './ActivePolicies/ActivePoliciesList'
import { PolicyManagementContextStore } from '../../context/PolicyManagementContext'
import Skeleton from '@material-ui/lab/Skeleton'
import {
  useRouteMatch,
  Switch,
  Route,
  useLocation,
  useHistory,
} from 'react-router-dom'
import { Policy } from './PolicyView/Policy'
import { PolicyCardSkeleton } from './PolicyCardSkeleton'
import { isBrowser } from 'react-device-detect'
import PolicyRenewalContext from '../../context/PolicyRenewalContext'
import { SessionContextStore } from '../../context/SessionContext'
import { BlueGrayBox } from '../Core/BlueGrayBox'
import { SessionService } from '../../services/SessionService'
import BuyingInsuranceContext from '../../context/BuyingInsuranceContext'
import ModificationContext from '../../context/ModificationContext'

export const PolicyManagementLayout = () => {
  const myPoliciesContext = React.useContext(PolicyManagementContextStore)
  const sessionContext = React.useContext(SessionContextStore)
  const isMobile = !useMediaQuery((theme) => theme.breakpoints.up('md'))
  const [tabIndex, setTabIndex] = React.useState(0)
  const location = useLocation()
  const history = useHistory()
  let { path, url } = useRouteMatch()

  const handleTabChange = (event, newValue) => {
    if (location.pathname != path) {
      history.replace(path)
    }
    setTabIndex(newValue)
  }

  React.useEffect(() => {
    if (!myPoliciesContext.loading_policies) {
      if (tabIndex == 0 && myPoliciesContext.active_policies.length == 0) {
        if (myPoliciesContext.scheduled_policies.length > 0)
          handleTabChange(undefined, 1)
        else if (myPoliciesContext.previous_policies.length > 0)
          handleTabChange(undefined, 2)
      }

      if (myPoliciesContext.active_policies.length == 1)
        history.push(
          `${url}/${myPoliciesContext.active_policies[0].insuranceId}`,
          { open_details: true }
        )
      else if (
        myPoliciesContext.active_policies == 0 &&
        myPoliciesContext.scheduled_policies.length == 1
      )
        history.push(
          `${url}/${myPoliciesContext.scheduled_policies[0].insuranceId}`,
          { open_details: true }
        )
    }
  }, [myPoliciesContext.loading_policies])

  const showTabs = isBrowser || location.pathname == path

  return (
    <Container maxWidth="lg" className="margin-top-basic">
      <FlexView hAlignContent={'center'} column={isMobile}>
        {showTabs && (
          <React.Fragment>
            {isMobile && (
              <div className="text-title textcenter black bold margin-top-basic">
                Policy management
              </div>
            )}
            <Tabs
              orientation={isMobile ? 'horizontal' : 'vertical'}
              variant="scrollable"
              value={tabIndex}
              indicatorColor={'primary'}
              textColor="primary"
              onChange={handleTabChange}>
              <Tab label="Active policies" />
              <Tab label="Scheduled" />
              <Tab label="Previous Policies" />
            </Tabs>
          </React.Fragment>
        )}
        <div className="full-width margin-left-basic margin-right-basic">
          {!isMobile && (
            <FlexView vAlignContent={'bottom'}>
              <div className="text-title black bold margin-top-basic">
                Policy Management
              </div>
              {SessionService.isBroker() && (
                <div className="margin-top-basic text-tiny margin-left-6">
                  <BlueGrayBox>{sessionContext.user.email}</BlueGrayBox>
                </div>
              )}
            </FlexView>
          )}
          <Switch>
            <Route exact path={path}>
              {tabIndex == 0 && (
                <Container maxWidth="lg">
                  {myPoliciesContext.loading_policies ? (
                    <FlexView column={isMobile}>
                      <PolicyCardSkeleton />
                    </FlexView>
                  ) : (
                    <ActivePoliciesList
                      policies={myPoliciesContext.active_policies}
                    />
                  )}
                </Container>
              )}
              {tabIndex == 1 && (
                <Container maxWidth="lg">
                  {myPoliciesContext.loading_policies ? (
                    <PolicyCardSkeleton />
                  ) : (
                    <ActivePoliciesList
                      policies={myPoliciesContext.scheduled_policies}
                    />
                  )}
                </Container>
              )}
              {tabIndex == 2 && (
                <Container maxWidth="lg">
                  {myPoliciesContext.loading_policies ? (
                    <PolicyCardSkeleton />
                  ) : (
                    <ActivePoliciesList
                      policies={myPoliciesContext.previous_policies}
                    />
                  )}
                </Container>
              )}
            </Route>
            <Route path={`${path}/:insuranceId`}>
              <PolicyRenewalContext>
                <BuyingInsuranceContext>
                  <ModificationContext>
                    <Policy />
                  </ModificationContext>
                </BuyingInsuranceContext>
              </PolicyRenewalContext>
            </Route>
          </Switch>
        </div>
      </FlexView>
    </Container>
  )
}
